module.exports = __webpack_public_path__ + "302d7ef30acff0bcbe8ac96565873891.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/spinnin-klaw.webm
// module id = 650
// module chunks = 0